var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackButtonIcon = function SvgBackButtonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 16.5h33v1H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.97 16.97 0l.708.707-16.97 16.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 17.007 16.97 16.97.708-.706L.708 16.3z"
  }))));
};
export default SvgBackButtonIcon;